import React, { useEffect, useState } from "react";
import { useAppDispatch } from "hooks/redux";
import { useTranslation } from "react-i18next";

import { GetPrintCartSigns } from "api/rpc/2024-04/facilityAdmin/teesheet/teeSheet";
import { StatusCode } from "api/protocols";

import { showError } from "redux/actions/ui";

import Sheet from "components/sheet/Sheet";
import { Select } from "components/select/index";
import CartOption1Preview from "../elements/CartOption1Preview";
import CartOption2Preview from "../elements/CartOption2Preview";
import CartOption3Preview from "../elements/CartOption3Preview";

import { ITeeTimeNew } from "redux/reducers/models/teetime";
import { ITournament } from "redux/reducers/models/tournament";
import { ILeague } from "redux/reducers/models/league";

interface IPrintCartSignsModal {
  open: boolean;
  teetime: ITeeTimeNew;
  tournaments: ITournament[];
  leagues: ILeague[];
  onOk: () => void;
  onCancel: () => void;
}

export default function PrintCartSignsModal(props: IPrintCartSignsModal) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [option, setOption] = useState<number>(1);
  const [event, setEvent] = useState<ITournament | ILeague>(undefined);

  useEffect(() => {
    setCartSignEvent();
  }, []);

  function setCartSignEvent() {
    let event = null;

    if (props.teetime.slots[0].tournament_id) {
      event = props.tournaments?.find(tournament => tournament.id === props.teetime.slots[0].tournament_id);
    } else if (props.teetime.slots[0].league_id) {
      event = props.leagues?.find(league => league.id === props.teetime.slots[0].league_id);
    }

    setEvent(event);
  }

  async function printCartSigns() {
    const cartSignsRes = await GetPrintCartSigns(
      {
        date: props.teetime.slots[0].date,
        league_id: props.teetime.slots[0].league_id,
        tournament_id: props.teetime.slots[0].tournament_id,
        shotgun_application_id: props.teetime.slots[0].shotgun_application_id,
        option: option,
      },
      true,
    );

    if (cartSignsRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error printing cart signs")));
      return;
    }

    window.open().document.write(String(cartSignsRes.data));
  }

  return (
    <Sheet
      open={props.open}
      title={t("client_side.tee_sheet.new_tee_sheet.modals.print_cart_signs_modal.001")}
      size="small"
      onOk={() => {
        void printCartSigns();
        props.onOk();
      }}
      onCancel={props.onCancel}
      okText={t("client_side.tee_sheet.new_tee_sheet.modals.print_cart_signs_modal.002")}
      overflow
    >
      <div className="mb-2">
        <Select label={t("Layout")} onChange={value => setOption(Number(value))} defaultValue={1}>
          <Select.Option value={1}>{t("Option 1")}</Select.Option>
          {/* <Select.Option value={2}>{"Option 2"}</Select.Option> */}
          <Select.Option value={3}>{t("Option 2")}</Select.Option>
        </Select>
      </div>
      {props.tournaments && option === 1 ? <CartOption1Preview teetime={props.teetime} event={event} /> : null}
      {props.tournaments && option === 2 ? <CartOption2Preview teetime={props.teetime} event={event} /> : null}
      {props.tournaments && option === 3 ? <CartOption3Preview teetime={props.teetime} event={event} /> : null}
    </Sheet>
  );
}
